import { render } from "./notification.vue?vue&type=template&id=ed43996c&scoped=true"
import script from "./notification.vue?vue&type=script&lang=js"
export * from "./notification.vue?vue&type=script&lang=js"

import "./notification.vue?vue&type=style&index=0&id=ed43996c&scoped=true&lang=css"

import exportComponent from "/var/www/worldchatbox/node_build/worldchatbox_dev2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed43996c"]])

export default __exports__